import type { AppContentVersionEntity } from '../entities/app-content.entity';
import type { GetAppContentUseCase } from './get-app-content.usecase';

export class GetPrivacyPolicyVersionsUseCase {
  constructor(private readonly getAppContent: GetAppContentUseCase) {}

  execute(): Promise<AppContentVersionEntity[]> {
    return this.getAppContent.executeVersions('privacyPolicy');
  }
}
